import { put, takeEvery, call } from "redux-saga/effects";
import * as apis from "../../network/apis/services";
import { getServiceCentersResponse } from "./slice";
import { showSnackMsg } from "../../utils/Helpers";
import {
  setCanShowEmptyState,
  setSkeletonObject,
} from "../Loader/slice";

export function* getServiceCentersSaga({ payload }) {
  try {
    yield put(getServiceCentersResponse({ serviceCenters: [], meta: {} }));
    yield put(setSkeletonObject({ field: "table", value: true }));
    
    const response = yield call(apis.getServiceCenters, payload);
    
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
    };
    
    const serviceCenters = response.data?.service_centers;

    yield put(getServiceCentersResponse({ serviceCenters:serviceCenters, meta, totalServiceCenters:response.data.total_service_centers }));
    yield put(setSkeletonObject({ field: "table", value: false }));
    
    if (serviceCenters.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setCanShowEmptyState(true));
    yield put(setSkeletonObject({ field: "table", value: false }));
    yield showSnackMsg(err.response?.data?.message);
  }
}

export default function* servicesSaga() {
  yield takeEvery('services/getServiceCentersRequest', getServiceCentersSaga);
}
